import React, { useState, useEffect } from 'react';
import { FaCheck } from 'react-icons/fa6';
import { MdOutlineAdd } from 'react-icons/md';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { authenticateApp } from '../../utils/auth';
import { getAuthenticatedApps, unauthApp } from '../../services/api'; // Updated to include `authApp`
import { DataState } from '../../context/DataProvider';
import Loader from '../../components/custom/Loader';
import { dataSources, integrationData } from '../../utils/constants';

let apps_data = [...integrationData, ...dataSources];
apps_data = apps_data.map((app, unique_index) => {
  app.unique_index = unique_index;
  return app;
});

const SetupPage = ({ bot_id }) => {
  const [isNewUser, setIsNewUser] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfNewUser = async () => {
      try {
        const response = await fetch('/api/check-user');
        const data = await response.json();
        if (data.isNewUser) {
          setIsNewUser(true);
        } else {
          navigate('/');
        }
      } catch (error) {
        navigate('/not-found');
      }
    };
    checkIfNewUser();
  }, [navigate]);

  const { userGoogleId: user_google_id } = DataState();

  const [loading, setLoading] = useState(false);
  const [integratedApps, setIntegratedApps] = useState([]);
  const [notIntegratedApps, setNotIntegratedApps] = useState([]);

  const fetchIntegratedApps = async () => {
    setLoading(true);
    try {
      const result = await getAuthenticatedApps(user_google_id, bot_id);
      const integrated = result.apps;
      // Filter triggerOptions to separate integrated and non-integrated apps
      const integratedApps = apps_data.filter(
        (app) => integrated.includes(app.value),
        // (integrated.includes(app.value) || app.value === "jira")
      );
      const notIntegratedApps = apps_data.filter(
        (app) => !integrated.includes(app.value),
        // (app) => (!integrated.includes(app.value) && app.value !== "jira")
      );

      setIntegratedApps(integratedApps);
      setNotIntegratedApps(notIntegratedApps);
    } catch (error) {
      toast.error('Failed to fetch integrated apps. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIntegratedApps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_google_id, bot_id]);

  const handleIntegrateButtonClick = async (selectedAppForIntegration) => {
    if (selectedAppForIntegration) {
      setLoading(true);
      await authenticateApp(
        selectedAppForIntegration.value,
        // bot_id,
        user_google_id,
        fetchIntegratedApps,
      );
    }
  };

  const handleUnAuthorisationButtonClick = async (selectedAppForUnauth) => {
    if (selectedAppForUnauth) {
      setLoading(true);
      const response = await unauthApp(
        selectedAppForUnauth.value,
        bot_id,
        user_google_id,
      );
      if (response.error) {
        toast.error(response.error);
      }
      fetchIntegratedApps();
    }
  };

  if (!isNewUser) {
    return <div className="bg-zinc-900 text-white">Loading...</div>;
  }
  return (
    <div className="h-screen w-screen bg-zinc-800">
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="bg-3 z-10 flex h-[90%] w-[90%] max-w-3xl flex-col rounded-lg">
          <div className="br-1 flex justify-between gap-3 border-b px-3 py-5">
            <h1 className="px-3 py-1.5 text-xl font-bold">Add Integrations</h1>
          </div>

          <div className="flex-grow overflow-y-auto p-4">
            {loading ? (
              <div className="text-p-text flex min-h-96 items-center justify-center">
                <span className="h-12">
                  <Loader />
                </span>
              </div>
            ) : (
              <>
                <div className="mb-4 flex flex-wrap gap-x-8 gap-y-4">
                  {integratedApps.map((item) => (
                    <div
                      key={item.unique_index}
                      className="flex items-center gap-2 rounded-full border border-zinc-400 p-1"
                    >
                      <div className="ml-2 rounded-lg bg-zinc-200 p-1">
                        <img
                          alt={item.label}
                          src={item.image}
                          className="h-7 w-7"
                        />
                      </div>
                      <div className="text-p-text ml-1 text-center text-lg font-semibold">
                        {item.label}
                      </div>
                      <button
                        onClick={() => handleUnAuthorisationButtonClick(item)}
                        className="text-s ml-6m ml-3 rounded-full bg-green-700 p-3 transition-all duration-300 hover:bg-green-800"
                      >
                        <FaCheck />
                      </button>
                    </div>
                  ))}
                  {notIntegratedApps.map((item, index) => (
                    <div
                      key={`Not-integrated-app-${item.unique_index}`}
                      className="flex items-center gap-2 rounded-full border border-zinc-400 p-1"
                    >
                      <div className="ml-2 rounded-lg bg-zinc-200 p-1">
                        <img
                          alt={item.label}
                          src={item.image}
                          className="h-7 w-7"
                        />
                      </div>
                      <div className="text-p-text ml-1 text-center text-lg font-semibold">
                        {item.label}
                      </div>
                      <button
                        onClick={() => handleIntegrateButtonClick(item)}
                        className="ml-6 rounded-full bg-zinc-100 p-3 text-sm font-bold text-zinc-700 transition-all duration-300 hover:bg-zinc-300"
                      >
                        <MdOutlineAdd />
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="flex items-center justify-end p-5">
            <Link
              to="/chat"
              className="flex h-10 w-fit items-center justify-center rounded-xl bg-zinc-200 px-4 font-semibold capitalize leading-[24px] text-zinc-800 first:sm:text-lg"
            >
              Continue
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetupPage;
